import _ from "lodash";

import { TBlueTable } from "@app/types/insider";

import {
  epBuilderAll,
  epBuilderAnyIssuer,
} from "../routines/mapperfn-pathbuilder";

import type { TIFCollectionItem } from "@app/types/insider";
const idxFn = (item: TIFCollectionItem) =>
  `${item.FF_ID}:${item.IFF_ID}:${item.FL_ID ?? "*"}`;

const mapFn = (item: TIFCollectionItem) => {
  console.log("item", item);
  const key = idxFn(item);
  console.log("key", key);
  return { _ID: key, ...item };
};

export const invoiceCollection: TBlueTable<TIFCollectionItem> = {
  name: "invoiceCollection",
  empty: {} as TIFCollectionItem,
  initialState: {},
  primaryKey: "_ID",
  mapWrite: (item: TIFCollectionItem) =>
    Object.assign({}, item, {
      _ID: `${item.FF_ID}:${item.IFF_ID}:${item.FL_ID ?? "*"}`,
    }),
  starfx: true,
  starfx_index: "_ID",
  idb: true,
  idb_indexes: [],
  apiUrl: "/select/incasari_sel_by_invoice_range",
  pkeyUrl: "/select/incasari_start_range_pkey",
  urlPathBuilder: epBuilderAnyIssuer, //WRONG
  bootPriority: -1,
  onmru: "new",
  oncsdb: "full",
  label: "Incasari",
  appContext: [],
};
